import * as types from '../API/ActionTypes';
import appConstants from '../appConstants';
import InitialState from './initialState';

export function changePasswordDataReducer(state = InitialState.changePasswordData, action) 
{
	switch (action.type)
	{
		case types.CHANGE_PASSWORD_RESPONSE:
			return action.changePasswordData;
		default:
			return state;
	}
}

export function changePasswordErrorReducer(state = InitialState.changePasswordErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.CHANGE_PASSWORD_ERROR:
			return action.changePasswordErrorFlag;
		default:
			return state;
	}
}

export function changePasswordLoadingReducer(state = InitialState.changePasswordLoading, action) 
{
	switch (action.type) 
	{
		case types.CHANGE_PASSWORD_LOADING:
			return action.changePasswordLoading;
		default:
			return state;
	}
}

export function forgotPasswordDataReducer(state = InitialState.forgotPasswordData, action) 
{
	switch (action.type) 
	{
		case types.FORGOT_PASSWORD_RESPONSE:
			return action.forgotPasswordData;
		default:
			return state;
	}
}

export function forgotPasswordErrorReducer(state = InitialState.forgotPasswordErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FORGOT_PASSWORD_ERROR:
			return action.forgotPasswordErrorFlag;
		default:
			return state;
	}
}

export function forgotPasswordLoadingReducer(state = InitialState.forgotPasswordLoading, action) 
{
	switch (action.type) 
	{
		case types.FORGOT_PASSWORD_LOADING:
			return action.forgotPasswordLoading;
		default:
			return state;
	}
}

export function loginDataReducer(state = InitialState.loginData, action) 
{
	switch (action.type) 
	{
		case types.LOGIN_RESPONSE:
			return action.loginData;
		case types.UPDATE_USER_LICENSE_AGREEMENT_STATUS:
			return {
				...state,
				licenseAgreedFlg : appConstants.CHAR_YES
			}
		case types.UPDATE_USER_PASSWORD_CHANGE_REQUIRED_STATUS:
			return {
				...state,
				passwordChangeRequiredFlg : appConstants.PASSWORD_CHANGE_REQUIRED_FLAG_YES
			}
		default:
			return state;
	}
}

export function loginErrorReducer(state = InitialState.loginErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.LOGIN_ERROR:
			return action.loginErrorFlag;
		default:
			return state;
	}
}

export function loginLoadingReducer(state = InitialState.loginLoading, action) 
{
	switch (action.type) 
	{
		case types.LOGIN_LOADING:
			return action.loginLoading;
		default:
			return state;
	}
}

export function loginReducer(state = InitialState.loginSuccessFlag, action) 
{
	switch (action.type) 
	{
		case types.LOGIN:
			return action.loginSuccessFlag;
		case types.LOGOUT:
			return false
		default:
				return state;
	}
}

export function updateUserLicenseAgreementStatusErrorReducer(state = InitialState.updateUserLicenseAgreementStatusErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_USER_LICENSE_AGREEMENT_STATUS_ERROR:
			return action.updateUserLicenseAgreementStatusErrorFlag;
		default:
			return state;
	}
}

export function updateUserLicenseAgreementStatusLoadingReducer(state = InitialState.updateUserLicenseAgreementStatusLoading, action) 
{
	switch (action.type) 
	{
		case types.UPDATE_USER_LICENSE_AGREEMENT_STATUS_LOADING:
			return action.updateUserLicenseAgreementStatusLoading;
		default:
			return state;
	}
}

export function feedbackTokenVerificationSuccessReducer(state = InitialState.feedbackTokenVerificationSuccess, action) 
{
	switch (action.type) 
	{
		case types.FEEDBACK_TOKEN_VERIFICATION_SUCCESS:
			return action.feedbackTokenVerificationSuccess;
		default:
			return state;
	}
}

export function feedbackTokenVerificationLoadingReducer(state = InitialState.feedbackTokenVerificationLoading, action) 
{
	switch (action.type) 
	{
		case types.FEEDBACK_TOKEN_VERIFICATION_LOADING:
			return action.feedbackTokenVerificationLoading;
		default:
			return state;
	}
}

export function feedbackTokenVerificationErrorReducer(state = InitialState.feedbackTokenVerificationErrorFlag, action) 
{
	switch (action.type) 
	{
		case types.FEEDBACK_TOKEN_VERIFICATION_ERROR:
			return action.feedbackTokenVerificationErrorFlag;
		default:
			return state;
	}
}
